module.exports = __webpack_public_path__ + "img/1.9ea23d59.jpg";